import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { RequestsContext } from "../../context/requests";
import { SalleContext } from '../../context/salle'
import { FilterSallesContext } from "../../context/filterSalles";

import { useNavigate } from "react-router-dom";

const Image = styled.img`
  width: 28px;
  height: 26px;
  object-fit: contain;

  @media screen and (max-width: 720px) {
    width: 21px;
    height: 21px;
    margin-left: 0.8rem;
  }
`;

const CheckBox = styled.input`
  border: 1px solid black;
  width: 19px;
  height: 19px;
`;

const CheckBoxTable = styled.input`
  position: relative;
  border: 1px solid black;
  width: 19px;
  height: 19px;
  top: 0.2rem;
  margin-right: 0.5rem;
`;

const TableListSallesOrderPrint = ({ structure }) => {
  const { option } = useContext(FilterSallesContext)

  const navigate = useNavigate()
  const [selectedItems, setSelectedItems] = useState([]);
  const {
    requests,
    getAll,
    getLast30Days,
    getByUniqDate,
    getRangeDate,
    handleSelectItems,
    haveRequests,
    typeFilter
  } = useContext(RequestsContext);
  const { getById, setSalleStatus } = useContext(SalleContext)

  useEffect(() => {

    if (typeFilter == "últimos 30 dias") {
      getLast30Days(option)
    }
    if (typeFilter == "por data") {
      getByUniqDate(option)
    }
    if (typeFilter == "por intervalo") {
      getRangeDate(option)
    }

    if (!typeFilter) {
      getAll(option)
    }


  }, [typeFilter]);


  useEffect(() => {
    if (selectedItems.length === requests.length) {
      requests.forEach((item) => {
        handleSelectItems(item.id, { target: { checked: true } }, item.type_delivery);
      });
    }
  }, [selectedItems]);

  return (
    <div className="container_startpn_table_categorys">
      <table>
        <thead>
          <tr>
            {structure?.map((item, index) =>
              item.name === "Selecionar" ? null : (
                <td key={index}>
                  {item.name}
                </td>
              )
            )}
          </tr>
        </thead>

        {haveRequests

          ?
          <tbody>

            {requests.length === 0 ? (
              <tr>
                {Array.from({ length: 5 }).map((_, index) => (
                  <td key={index}>
                    <Skeleton width="100%" />
                  </td>
                ))}
              </tr>
            ) : (
              requests.map((item) => {
                const formattedDate = new Date(item.createdAt).toLocaleDateString("pt-BR");
                const formattedPrice = (item.price * item.quantity).toLocaleString("pt-BR", {
                  minimumFractionDigits: 2,
                });

                return (
                  <tr key={item.id}>

                    <td >#{item.id}</td>
                    <td >#{item.sku}</td>
                    <td >{formattedDate}</td>
                    <td >{item.userName}</td>
                    <td >R$ {formattedPrice}</td>
                  </tr>
                );
              })
            )}
          </tbody>
          :
          <tbody></tbody>
        }


      </table>
    </div>
  );
};

export default TableListSallesOrderPrint;
